import {length} from 'redux-form-validators';

export default opts =>
  length({
    message: {
      id: 'validation.wrongLength'
    },
    ...opts
  });



// WEBPACK FOOTER //
// ./validators/units/length.js